// extracted by mini-css-extract-plugin
export default {"container":"StellarExpertLinkIcon_container__qL5x7","link":"StellarExpertLinkIcon_link__W58iL"};